import { type AxiosError } from 'axios';

import { IResponseWithCode } from '@gbs-monorepo-packages/auth';
import { IResponseData } from '@gbs-monorepo-packages/common';

import { adminApi } from './api';
import { type IContributionDataDTO } from './contributionClass';
import { type IPlanDTO } from './plan';

const SpreadQuoteURL = 'api/spread-quote';
const QuoteURL = 'api/quotes';

export interface IPageType {
  medical: number;
  dental: number;
  vision: number;
  life: number;
  disability: number;
  accident: number;
  criticalIllness: number;
  contribution: number;
}

export interface IQuoteDateDTO {
  id: number;
  effectiveDate: string;
  period: string;
  createdDate: string;
}

export interface IAutobuildPageDTO {
  pageType: IPageType;
  pageId: number;
  title: string;
  spreadPlans: IPlanDTO[];
  contributionData: IContributionDataDTO[];
}

export type AutobuildSpreadPlansOrder = Record<string, Record<string, string>>;

export interface IGenerateAutobuildPage {
  pageType: IPageType;
  pageId: number;
  title: string;
  spreadPlans: AutobuildSpreadPlansOrder;
  contribution: Record<number, number>;
}

export interface IAutobuildGenerate {
  quoteId: string;
  courseTemplateId: number;
  autoBuildPages: IGenerateAutobuildPage;
}

export const getAutobuildPages = async (
  quoteId: number,
  courseTemplateId: number
): Promise<IAutobuildPageDTO[]> => {
  const result = await adminApi
    .get<IResponseData<IAutobuildPageDTO[]>>(
      `${SpreadQuoteURL}/${quoteId}/build-course/pages/${courseTemplateId}`
    )
    .then((resp) => resp.data.data)
    .catch((err) => {
      throw err;
    });

  return result;
};

export const getQuotesDatesByCompany = async (
  companyId: string
): Promise<IQuoteDateDTO[]> => {
  const result = await adminApi
    .get<IResponseData<IQuoteDateDTO[]>>(
      `${QuoteURL}/client/${companyId}/dates`
    )
    .then((resp) => resp.data.data)
    .catch((err) => {
      throw err;
    });

  return result;
};

export const generateAutobuild = async (
  { courseTemplateId, autoBuildPages }: IAutobuildGenerate,
  quoteId: string
): Promise<IResponseData> => {
  const toGenerate: Partial<IAutobuildGenerate> = {};

  courseTemplateId && (toGenerate.courseTemplateId = courseTemplateId);
  autoBuildPages && (toGenerate.autoBuildPages = autoBuildPages);

  const response = await adminApi
    .post<IResponseData>(
      `${SpreadQuoteURL}/${quoteId}/build-course`,
      toGenerate
    )
    .then((resp) => resp.data)
    .catch((err: AxiosError<IResponseWithCode>) => {
      throw err;
    });

  return response;
};
